import {Column} from "typeorm";

export class Periodo {
    @Column({type:"datetime"})
    inicio?: Date
    @Column({type:"datetime"})
    fim?: Date
    constructor() {
        this.inicio = new Date()
    }


}
